<template>
    <v-layout>
        <v-flex>
            <table class="lstTable">
                <tr>
                    <th width="20px">{{$t('lang.common.no')}}</th>
                    <th width="100px">{{$t('lang.material.materialType')}}</th>
                    <th width="100px">{{$t('lang.purchase.material')}}</th>
                    <th width="50px">{{$t('lang.material.code')}}</th>
                    <th width="50px">{{$t('lang.purchase.unit')}}</th>
                    <th width="100px" v-if="byProcess !=2">{{$t('lang.purchase.pack')}}</th>
                    <th width="50px" v-if="byProcess !=2">{{$t('lang.purchase.remain')}}</th>
                    <th width="50px" v-if="byProcess!=1 && byProcess !=2">{{$t('lang.purchase.totalByProcess')}}</th>
                    <th width="50px" v-if="byProcess!=1 && byProcess !=2">{{$t('lang.purchase.reserved')}}</th>
                    <th width="50px" v-if="byProcess !=2">{{$t('lang.purchase.buyNumber')}}</th>
                    <th width="50px" v-if="showBuy || byProcess == 2">{{$t('lang.purchase.buyNumberPropose')}}</th>
                    <th width="50px" v-if="byProcess == 1">{{$t('lang.purchase.purpose')}}</th>
                    <th width="50px" v-if="byProcess == 2">{{$t('lang.purchase.actualImport')}}</th>
                    <th width="50px" v-if="byProcess == 2">{{$t('lang.purchase.buyAdditionNumber')}}</th>
                    <th width="50px" v-if="showBuy || byProcess == 2">{{$t('lang.purchase.price')}}</th>
                    <th width="100px" v-if="showBuy || byProcess == 2">{{$t('lang.purchase.money')}}</th>
                    <th width="100px" v-if="showBuy && byProcess !=2">{{$t('lang.purchase.vendor')}}</th>
                    <th width="100px" v-if="byProcess !=2">{{$t('lang.purchase.deliverDate')}}</th>
                    <th width="150px" v-if="showBuy && byProcess !=2">{{$t('lang.common.note')}}</th>
                    <th width="50px" v-if="(status <=2 && ($store.state.auth.user.role ==roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER || (($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                            ||  $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR || $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT ) && creator == $store.state.auth.user.userId))) ">
                        {{$t('lang.common.delete')}}
                    </th>
                    <!--th width="10%">Thời gian giao hàng</th-->
                </tr>
                <template v-for="(item,idx) in lstMaterial">
                    <tr v-if="item.row == 0" :key="idx">
                        <td style="font-weight: bold;text-align: center">{{idx+1}}</td>
                        <td style="font-weight: bold">{{item.typeName}}</td>
                        <td :colspan="colspan">Không có vật tư</td>
                    </tr>
                    <tr v-else-if="item.show" :class="getInActive(item)" :key="idx">
                        <td style="font-weight: bold;text-align: center">{{idx+1}}</td>
                        <td style="font-weight: bold" :rowspan="item.row"
                            v-if="item.row != undefined && item.row != null">{{item.typeName}}
                        </td>
                        <td>{{item.materialName}}</td>
                        <td>{{item.materialCode}}</td>
                        <td>{{item.unit}}</td>
                        <td v-if="byProcess !=2">{{item.pack}}</td>
                        <td v-if="byProcess !=2" style="text-align: right">{{item.remain | currency}}</td>
                        <td style="text-align: right" v-if="byProcess!=1 && byProcess !=2">{{item.total | currency}}
                        </td>
                        <td v-if="byProcess!=1 && byProcess !=2" style="text-align: right">
                            <c-input-number v-model="item.reserved" @change="calculateBuyNumber(item)"
                                            v-if="status<=2 && isEdit"/>
                            <template v-else>
                                {{item.reserved | currency}}
                            </template>
                        </td>
                        <td style="text-align: right" v-if="byProcess !=2">
                            <c-input-number v-model="item.buyNumber"
                                            v-if="byProcess==1&& status <=2 &&($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                                   ||  creator ==$store.state.auth.user.userId)"
                                            @change="updateBuyNumber(item)"/>
                            <template v-else>
                                {{item.buyNumber | currency}}
                            </template>
                        </td>

                        <td style="text-align: right" v-if="showBuy || byProcess == 2">
                            <c-input-number v-model="item.buyNumberPropose" @change="calculateTotal(item)" v-if="byProcess != 2 && ( (status <=2 || status == 4) &&
                            ($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE|| $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR || $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT))"/>
                            <template v-else>
                                {{item.buyNumberPropose | currency}}
                            </template>
                        </td>
                        <td v-if="byProcess == 1">
                            <textarea type="text" v-model="item.purpose" v-if="status <=2 && ($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER || (($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                              ||  $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR || $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT) && creator == $store.state.auth.user.userId))"/>
                            <template v-else>
                                {{item.purpose}}
                            </template>

                        </td>

                        <td style="text-align: right" v-if="byProcess == 2">
                            {{item.actualImport | currency}}
                        </td>
                        <td style="text-align: right" v-if="byProcess == 2">
                            <c-input-number v-model="item.buyNumberAddition" @change="calculateTotal(item)"
                                            v-if="( (status <=2 || status == 4) && creator == $store.state.auth.user.userId)"/>
                            <template v-else>
                                {{item.buyNumberAddition | currency}}
                            </template>
                        </td>
                        <td v-if="showBuy|| byProcess ==2" style="text-align: right">
                            <c-input-number v-model="item.price" @change="calculateTotal(item)" v-if="( (status <=2 || status == 4 )&& $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE)
                            || (status <=2 && ($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR|| $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT) && creator == $store.state.auth.user.userId)"/>
                            <template v-else>
                                {{item.price | currency}}
                            </template>

                        </td>
                        <td v-if="showBuy || byProcess == 2" style="text-align: right">
                            {{item.money | currency }}
                        </td>
                        <td v-if="showBuy && byProcess != 2">
                            <!--input type="text" v-model="item.vendor"
                                   v-if="status <=2 && $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE"/-->
                            <v-select
                                    v-if="(status <=2 || status ==4) && ($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE || ($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT && creator == $store.state.auth.user.userId))"
                                    :items="supplyOfMaterial[item.materialId]"
                                    label=""
                                    small
                                    v-model="item.vendor"
                                    :key="'vendor_'+item.materialId"
                                    :name="'vendor_'+item.materialId"
                                    item-value="partnerName"
                                    item-text="partnerName"
                                    @change="onChangeSupply($event, idx)"
                            />
                            <template v-else>
                                {{item.vendor}}
                            </template>
                        </td>
                        <td v-if="byProcess != 2">
                            <i-datepicker 
                                v-if="($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER && status <=2)
                                    || (status == 1 && creator == $store.state.auth.user.userId)"
                                :key="idx+item.typeId+item.materialId"
                                v-model="item.receiveDate"
                                v-validate="'date_after_now'"
                                label=""
                                :data-vv-as="$t('lang.purchase.deliverDate')"
                                :name="'receiveDate'+idx"
                                :error-messages="errors.first('receiveDate'+idx)"
                            />
                            <template v-else>
                                {{item.receiveDate | formatDate}}
                            </template>

                        </td>
                        <td v-if="showBuy && byProcess != 2">
                            <textarea label=""
                                      :data-vv-as="$t('lang.common.note')"
                                      v-model="item.note"
                                      :id="'note'+idx"
                                      :name="'note'+idx"
                                      :error-messages="errors.first('note'+idx)"
                                      v-if="(status <=2|| status ==4) && ($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE || ($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT && creator == $store.state.auth.user.userId))"/>
                            <template v-else>
                                {{item.note}}
                            </template>
                        </td>
                        <td style="text-align: center" v-if="(status <=2 && ($store.state.auth.user.role ==roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER || (($store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                            ||  $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR || $store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT) && creator == $store.state.auth.user.userId))) ">
                            <v-btn icon @click="deleteItem(item)">
                                <v-icon color="red">delete</v-icon>
                            </v-btn>

                        </td>

                    </tr>

                </template>
                <tr v-if="showBuy">
                    <td :colspan="getColspan()" style="font-weight: bold">Tổng tiền</td>
                    <td style="text-align: right">{{lstData.total | currency}}</td>
                    <td colspan="3" v-if="byProcess != 2"></td>
                </tr>
            </table>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapGetters} from "vuex";
    import {areaContants} from "@/constants";
    import {roleConstants} from "@/constants";
    import axios from "axios";

    export default {
        name: "RequestSummary",
        components: {},
        props: {
            crop: {
                type: Object,
                default: () => {
                    return null;
                },
            },
            lstProcedureWh: {
                type: Array,
                default: () => {
                },
            },
            materialTypeSelected: {
                type: Array,
                default: [],
            },
            fromDate: {
                type: String,
                default: () => {
                    return null;
                }
            },
            toDate: {
                type: String,
                default: () => {
                    return null;
                }
            },
            seedNumber: {
                type: Array,
                default: () => {
                    return null;
                }
            },
            byProcess: {
                type: Number,
                default: () => {
                    return 0;
                },
            },
            status: {
                type: Number,
                default: () => {
                    return 0;
                },
            },
            isEdit: {
                type: Boolean,
                default: () => {
                    return true;
                },
            },
            creator: {
                type: Number | String,
                default: () => {
                    return 0;
                },
            }

        },
        data: () => ({
            numberGList: areaContants.numberGList,
            shrimpAge: 0,
            listProcedureWh: [],
            listG: [],
            lstData: [],
            lstMaterial: [],
            lstMaterialType: [],
            lstSupply: [],
            lstTmpMaterial: [],
            supplyOfMaterial: {},
            lstProcedureData: [],
            item: {
                procedureId: '',
                numberG: ''
            }
        }),
        computed: {
            showBuy() {
                if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT) {
                    return true;
                } else {
                    return false;
                }
            },

            colspan() {
                if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT) {
                    if (this.byProcess == 1) {
                        return 10;
                    } else {
                        return 15;
                    }
                } else {
                    if (this.byProcess == 1) {
                        return 12;
                    } else {
                        return 13;
                    }
                }
            }
        },

        created() {
            //this.onViewProcedure();
            this.roleConstants = roleConstants;
            this.getSupply();
            this.getMaterialist();
        },

        watch: {
            crop: {
                handler(val) {
                    this.item.procedureId = val.processId;
                },
                deep: true
            },

            lstMaterial: {
                handler(val) {
                    this.getMaterialist();
                },
                deep: true
            },

            materialTypeSelected() {
                this.reCalculate();
            }
        },
        methods: {
            getInActive(item){
                if(item.status == 0){
                    return "inactive";
                }   else {
                    return  "";
                }
            },

            resetSupplyOfMaterial() {
                this.supplyOfMaterial = {};
                for (let i = 0; i < this.lstTmpMaterial.length; i++) {
                    let items = [];
                    if (this.lstTmpMaterial[i].supplyId != undefined && this.lstTmpMaterial[i].supplyId != null) {
                        let supplys = this.lstTmpMaterial[i].supplyId.split(",");
                        for (let j = 0; j < supplys.length; j++) {
                            for (let h = 0; h < this.lstSupply.length; h++) {
                                if (supplys[j] == this.lstSupply[h].partnerId) {
                                    items.push(this.lstSupply[h]);
                                    break;
                                }
                            }
                        }
                    }
                    this.supplyOfMaterial[this.lstTmpMaterial[i].materialId] = items;
                }
                // console.log(this.supplyOfMaterial);
                //console.log(this.lstSupply);
                this.$forceUpdate();
            },

            setInActiveMaterial(){
                for (let i = 0; i < this.lstTmpMaterial.length; i++) {
                    let items = [];
                    if (this.lstTmpMaterial[i].status == 0) {
                        for(let j=0;j<this.lstMaterial.length;j++){
                            if(this.lstMaterial[i].materialId == this.lstTmpMaterial[i].materialId){
                                this.lstMaterial[i].status = 0;
                                break;
                            }
                        }
                    }
                }
                this.$forceUpdate();
            },

            getSupply() {
                axios.post(process.env.VUE_APP_API_URL + "/partner/search?sortField=updatedAt&pageSize=-1&page=-1&orderBy=desc", {status: 1}).then(
                    data => {
                        this.lstSupply = data.items;
                        this.resetSupplyOfMaterial();
                    }
                )
            },

            getMaterialist() {
                console.log('====getMaterialist=====');
                console.log(this.lstMaterial);
                let ids = null;
                for (let i = 0; i < this.lstMaterial.length; i++) {
                    if (this.lstMaterial[i].materialId != undefined && this.lstMaterial[i].materialId != null) {
                        if (ids == null) {
                            ids = this.lstMaterial[i].materialId;
                        } else {
                            ids += "," + this.lstMaterial[i].materialId;
                        }
                    }
                }
                axios.post(process.env.VUE_APP_API_URL + "/material/byIds?ids=" + ids).then(
                    data => {
                        this.lstTmpMaterial = data;
                        this.resetSupplyOfMaterial();
                        this.setInActiveMaterial();
                    }
                )
            },

            getColspan() {
                if (this.byProcess == 1) {
                    return 11;
                } else if (this.byProcess == 2) {
                    return 9;
                } else {
                    return 12;
                }
            },

            viewProcedure(data) {
                this.lstData = data;
                this.reCalculate();
                this.calculateSum();

            },

            calculateBuyNumber(item) {
                item.buyNumber = parseFloat(item.total);
                //console.log(isNaN(item.reversed));
                //console.log(item.reversed);
                let reserved = parseFloat(item.reserved);
                if (!isNaN(reserved)) {
                    item.buyNumber += reserved;
                }

                if (!isNaN(item.remain)) {
                    item.buyNumber -= item.remain;
                    if (item.buyNumber < 0) {
                        item.buyNumber = 0;
                    }
                }

                item.buyNumberPropose = item.buyNumber;
                item.money = Math.ceil(parseFloat(item.buyNumberPropose) * parseFloat(item.price));
                this.calculateSum();
                this.$forceUpdate();
            },

            updateBuyNumber(item) {
                item.buyNumberPropose = item.buyNumber;
                item.money = Math.ceil(parseFloat(item.buyNumberPropose) * parseFloat(item.price));
                this.calculateSum();
                this.$forceUpdate();
            },

            calculateTotal(item) {
                if (this.byProcess == 2) {
                    item.money = Math.ceil(parseFloat(item.buyNumberAddition) * parseFloat(item.price));
                } else {
                    item.money = Math.ceil(parseFloat(item.buyNumberPropose) * parseFloat(item.price));
                }
                this.calculateSum();
                this.$forceUpdate();
            },

            calculateSum() {
                this.lstData.total = 0;
                for (let i = 0; i < this.lstData.lstMaterial.length; i++) {
                    if (this.lstData.lstMaterial[i].show && this.lstData.lstMaterial[i].money != undefined && this.lstData.lstMaterial[i].money != null) {
                        this.lstData.total += this.lstData.lstMaterial[i].money;
                    }
                }
            },

            deleteItem(item) {
                if (confirm("Bạn có chắc xóa vật tư: " + item.materialName + " khỏi đề nghị mua hàng không?")) {
                    for (let i = 0; i < this.lstData.lstMaterial.length; i++) {
                        if (this.lstData.lstMaterial[i].materialId == item.materialId) {
                            this.lstData.lstMaterial.splice(i, 1);
                            break;
                        }
                    }
                    this.$emit("updateMaterialType",item);
                    //
                    // update material check
                    //
                    this.reCalculate();
                }
            },

            reCalculate() {
                console.log("- recalculate ---");
                //console.log(this.lstMaterialType);
                this.lstMaterial = this.lstData.lstMaterial;
                if (this.lstMaterial == undefined || this.lstMaterial == null) {
                    this.lstMaterial = [];
                }
                this.lstMaterialType = this.materialTypeSelected;
                console.log(this.lstMaterialType);
                console.log(this.materialTypeSelected);
                let i, j;

                this.lstMaterial.sort((o1, o2) => {
                    if (o1.typeId == o2.typeId) {
                        return o1.materialName.localeCompare(o2.materialName);
                    } else {
                        return o1.typeId - o2.typeId;
                    }
                })
                for (j = this.lstMaterial.length - 1; j >= 0; j--) {
                    this.lstMaterial[j].row = null;
                    this.lstMaterial[j].show = false;
                    if (this.lstMaterial[j].materialId == undefined || this.lstMaterial[j].materialId == null) {
                        this.lstMaterial.splice(j, 1);
                    }
                }
                console.log("--- lstmaterial type---")
                console.log(this.lstMaterialType);

                for (i = 0; i < this.lstMaterialType.length; i++) {
                    this.lstMaterialType[i].count = 0;
                    for (j = 0; j < this.lstMaterial.length; j++) {
                        if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId
                            && this.lstMaterial[j].materialId != undefined && this.lstMaterial[j].materialId != null) {
                            this.lstMaterial[j].show = true;
                            this.lstMaterialType[i].count++;
                        }
                    }
                    if (this.lstMaterialType[i].count == 0) {
                        /*
                                                this.lstMaterial.push({
                                                    typeId: this.lstMaterialType[i].categoryId,
                                                    typeName: this.lstMaterialType[i].categoryName,
                                                    row: 0,
                                                    show:true
                                                })
                        */
                    } else {
                        for (j = 0; j < this.lstMaterial.length; j++) {
                            if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                                this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryName;
                                this.lstMaterial[j].row = this.lstMaterialType[i].count;
                                break;
                            }
                        }
                    }

                }
                //console.log(this.lstMaterial);
                this.calculateSum();

            },
            onChangeSupply($event, idx) {
                //console.log($event);
                const supply = this.lstSupply.find((o) => o.partnerName == $event);
                //console.log(supply);
                if (supply != undefined) {
                    this.lstMaterial[idx].supplySelected = supply.partnerId;
                }
            },
        },
    };
</script>

<style scoped>
</style>